import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-audio',
    templateUrl: './audio.component.html',
    styleUrls: ['./audio.component.scss']
})
export class AudioComponent implements  OnDestroy, OnChanges {

    constructor() {
    }

    @Input()
    audioUrl;

    isPlaying = false;

    private audioObj = new Audio();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.audioUrl && changes.audioUrl.currentValue != changes.audioUrl.previousValue) {
            this.isPlaying = false;
            this.audioObj.src = changes.audioUrl.currentValue;
            this.audioObj.load();
        }
    }


    ngOnDestroy(): void {
        this.audioObj.pause();
    }

    play() {
        this.audioObj.play();
        this.isPlaying = true;
    }

    pause() {
        this.audioObj.pause();
    }

    stop() {
        this.audioObj.pause();
        this.audioObj.currentTime = 0;
        this.isPlaying = false;
    }
}
